import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export class LookupAccessRight {
  public static PERFORM_LOOKUP: AuthenticationAccessRight = ({ menuDisplayLevel }) =>  menuDisplayLevel === 0;
}
